import { contestConstants } from '../constants';

export const contestActions = {
    newConcursoParticipacion: (data) => ({ type: contestConstants.CONTEST_SEND_REQUEST, data }),
    clearState: () => ({ type: contestConstants.CONTEST_CLEAR_STATE }),
};
